<list-renderer [listTemplate]="listTemplate"></list-renderer>